<template>
  <div class="section section_portfolio">
    <h2 class="section__title grey--text" data-aos="fade-up">{{ model.menu_title }}</h2>
    <div class="portfolio" v-for="(item, i) in model.items" :key="i">
      <router-link :to="lang + '/project/' + item.slug">
      <img class="portfolio__img" data-aos="fade-up" :src="getImage(item.cover)" alt="portfolio_aks1">
      </router-link>
      <div class="portfolio__bg" :style="{ backgroundImage: 'url(' + getImage(item.cover_bg) + ')'}"></div>
      <div class="portfolio__title" data-aos="fade-up" v-html="item.title"></div>
      <div class="city" data-aos="fade-up" v-html="item.description"></div>
      <router-link data-aos="fade-up" class="link_more black--text"
                   :to="lang + '/project/' + item.slug"
      ><span>{{ more }}</span> <img src="@/assets/svg/arrow.svg"></router-link>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['model'],
    methods: {
      getImage(image) {
        return this.$apiHost + image
      }
    },
    computed: {
      lang () {
        if (!this.$route.params.lang) {
          return ''
        }

        return this.$route.params.lang
      },
      more() {
        if (!this.$route.params.lang) {
          return 'посмотреть'
        } else if (this.$route.params.lang === 'fr') {
          return 'regarder'
        } else {
          return 'more'
        }
      },
    },
  }
</script>

<style lang="scss" scoped>

  .section_portfolio {
    height: auto;
  }

  .portfolio {
    margin-top: 73px;
    z-index: 9;
    width: 100%;
    padding-left: 35%;
    display: block;
    position: relative;
    font-family: "CirceRegular", sans-serif;
    margin-left: 10%;
    @media screen and (max-width: 800px) {
      margin-right: 0;
      margin-left: 0;
      padding: 0;
    }
  }

  .portfolio:nth-child(odd) {
    padding-left: 0;
    padding-right: 45%;
    @media screen and (max-width: 800px) {
      margin-right: 0;
      margin-left: 0;
      padding: 0;
    }
  }

  .portfolio:nth-child(2):after {
    position: absolute;
    content: '';
    width: 60%;
    height: 150%;
    left: -10%;
    top: 30%;
    z-index: -1;
    opacity: .66;
    background: url('../../assets/img/MA_1920_beton2.png');
    background-position: right;
    background-repeat: no-repeat;

  }

  .portfolio:nth-child(5):after {
    position: absolute;
    content: '';
    width: 50%;
    height: 130%;
    top: 40%;
    right: 0;
    z-index: -2;
    opacity: .66;
    background: url('../../assets/img/MA_1920_beton3.png');
    background-position: left;
    background-repeat: no-repeat;

  }

  .portfolio__img {
    width: 100%;
    margin-bottom: 30px;
  }

  .portfolio__title {
    font-size: 24px;
    max-width: 80%;
    line-height: 1.3;
    margin-bottom: 0;
    @media screen and (max-width: 1400px) {
      font-size: 22px;
    }
    @media screen and (max-width: 800px) {
      width: 80%;
      margin-left: 10%;
    }
  }

  .portfolio__link {
    color: black;
    display: flex;
    height: 40px;
    align-items: center;
    font-size: 20px;
    font-weight: 700;
    transition: .3s;
    @media screen and (max-width: 800px) {
      margin-left: 10%;
    }

  }

  .portfolio__bg {
    position: absolute;
    width: 45%;
    z-index: -1;
    height: 70%;
    top: 0;
    left: 7%;
    background-repeat: no-repeat;
    background-position: left center;
    background-size: contain;
  }

  .portfolio:nth-child(odd) .portfolio__bg {
    left: auto;
    right: 0;
    width: 60%;
    height: 60%;
    top: 10%;
  }

  .city {
    font-size: 18px;
    line-height: 1.2;
    @media screen and (max-width: 800px) {
      font-size: 16px;
    }
  }

  .bk_portfolio-block-1 {
    width: 30%;
    position: absolute;
    left: 0;
    top: 50%;
    height: 108%;
    background: url('../../assets/img/MA_1920_beton2.png');
    background-repeat: no-repeat;
    @media screen and (max-width: 800px) {
      display: none;
    }
  }

  .bk_portfolio-block-2 {
    position: absolute;
    width: 48%;
    right: 0;
    bottom: 0;
    height: 130%;
    background: url('../../assets/img/MA_1920_beton3.png');
    background-repeat: no-repeat;
    @media screen and (max-width: 800px) {
      display: none;
    }
  }

  .link_more {
    display: flex;
    font-size: 18px;
    color: #a4a5a4;
    text-decoration: none;
    height: 50px;
    align-items: center;
    justify-content: space-between;
    width: 260px;
    transition: .2s;
  }

  .link_more img {
    width: 120px;

  }

  .link_more span {
    display: block;
    font-weight: 600;
  }

  .link_more:hover {
    opacity: .66;
  }

</style>



// WEBPACK FOOTER //
// src/components/home-page-components/PortfolioBlock.vue